import { IGetCentroCustoEmpreendimentoDropDownUseCase } from "../../../presentation/useCases/read/get_centro_custo_empreendimento_dropdown_use_case";
import { CentroCustoDropDown } from "../../models/centro_custo_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetCentroCustoEmpreendimentoDropDownUseCase
 */

export class GetCentroCustoEmpreendimentoDropDownUseCase implements IGetCentroCustoEmpreendimentoDropDownUseCase {
  constructor(
    private readonly repository: ICommonsRepository,
  ) { }

  async getCentroCustoEmpreendimentoDropDown(idEmpreendimento?: number | null): Promise<CentroCustoDropDown[]> {
    return await this.repository.getCentroCustoEmpreendimentoDropDown(idEmpreendimento);
  }
}
